import { render, staticRenderFns } from "./BackToLoginBtn.vue?vue&type=template&id=1d2b3768&scoped=true"
import script from "./BackToLoginBtn.vue?vue&type=script&lang=ts"
export * from "./BackToLoginBtn.vue?vue&type=script&lang=ts"
import style0 from "./BackToLoginBtn.vue?vue&type=style&index=0&id=1d2b3768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2b3768",
  null
  
)

export default component.exports